import { apiClient } from "../apiClient";

const ENDPOINT = "mau-email";

/** Nhóm mẫu — khớp MauEmailNhom phía máy chủ. */
export const MAU_EMAIL_NHOM = {
  NHAC_HOC_PHI: "nhac_hoc_phi",
  HUY_HOC_PHAN: "huy_hoc_phan",
  KHAC: "khac",
} as const;

export const TEN_NHOM_MAU_EMAIL: Record<string, string> = {
  [MAU_EMAIL_NHOM.NHAC_HOC_PHI]: "Nhắc nộp học phí",
  [MAU_EMAIL_NHOM.HUY_HOC_PHAN]: "Thông báo hủy học phần",
  [MAU_EMAIL_NHOM.KHAC]: "Thông báo chung",
};

/** Mã các ô lọc có thể hiện ở màn gửi — khớp MauEmailOLoc phía máy chủ. */
export const O_LOC = {
  SINH_VIEN: "sinh_vien",
  HE: "he",
  KHOA: "khoa",
  KHOA_HOC: "khoa_hoc",
  NGANH: "nganh",
  LOP: "lop",
  KHOI_NGANH: "khoi_nganh",
  DOI_TUONG: "doi_tuong",
  QUOC_TICH: "quoc_tich",
  KHOAN_THU: "khoan_thu",
  DOT_DANG_KY: "dot_dang_ky",
  TINH_CHAT_HOC: "tinh_chat_hoc",
  TRANG_THAI_HOC: "trang_thai_hoc",
  CONG_NO: "cong_no",
  SO_TIEN_NO_TU: "so_tien_no_tu",
  PHAM_VI: "pham_vi",
} as const;

/** Nhãn của từng ô lọc BẬT/TẮT ĐƯỢC trong mẫu.
 * ★ KHÔNG có "Sinh viên": ô đó luôn hiện ở màn gửi (chọn riêng vài em lúc gửi), không phải
 * thiết lập của mẫu nên không cho tắt. */
export const TEN_O_LOC: { ma: string; ten: string }[] = [
  { ma: O_LOC.HE, ten: "Hệ đào tạo" },
  { ma: O_LOC.KHOA, ten: "Khoa" },
  { ma: O_LOC.KHOA_HOC, ten: "Khóa học" },
  { ma: O_LOC.NGANH, ten: "Ngành" },
  { ma: O_LOC.LOP, ten: "Lớp" },
  { ma: O_LOC.KHOI_NGANH, ten: "Khối ngành" },
  { ma: O_LOC.DOI_TUONG, ten: "Đối tượng" },
  { ma: O_LOC.QUOC_TICH, ten: "Quốc tịch" },
  { ma: O_LOC.KHOAN_THU, ten: "Khoản thu" },
  { ma: O_LOC.DOT_DANG_KY, ten: "Đợt đăng ký tín chỉ" },
  { ma: O_LOC.TINH_CHAT_HOC, ten: "Tính chất học" },
  { ma: O_LOC.TRANG_THAI_HOC, ten: "Trạng thái học" },
  { ma: O_LOC.CONG_NO, ten: "Tình trạng công nợ" },
  { ma: O_LOC.SO_TIEN_NO_TU, ten: "Số tiền nợ từ" },
  { ma: O_LOC.PHAM_VI, ten: "Phạm vi kỳ / năm" },
];

/** Tình trạng công nợ — đúng các giá trị thủ tục công nợ nhận. */
export const TINH_TRANG_CONG_NO = [
  { value: "chua-hoan-thanh", label: "Còn thiếu tiền" },
  { value: "all-co-cong-no", label: "Có phát sinh công nợ" },
  { value: "con-thua-thieu", label: "Còn thừa hoặc thiếu" },
  { value: "nop-thua", label: "Nộp thừa" },
  { value: "hoan-thanh", label: "Đã nộp đủ" },
  { value: "all", label: "Tất cả" },
];

export interface IMauEmailTieuChi {
  /** Chọn đích danh sinh viên — rỗng = không lọc. */
  id_svs: string[];
  /** true = lấy học kỳ / năm học đang chọn trên thanh trên; false = dùng kỳ khai trong mẫu. */
  theo_ky_dang_chon: boolean;
  hoc_ky: number;
  nam_hoc: string;
  /** "ky" | "nam" | "all" */
  filter_phamvi: string;
  id_hes: number[];
  id_khoas: number[];
  khoa_hocs: number[];
  id_nganhs: number[];
  id_lops: number[];
  id_khoi_nganhs: number[];
  id_doi_tuongs: number[];
  id_quoc_tichs: number[];
  id_thu_chis: number[];
  ky_dang_kys: number[];
  tinh_chat_hocs: number[];
  trang_thai_hocs: number[];
  filter_congno: string;
  /** Chỉ gửi khi còn thiếu từ mức này (đồng). 0 = không chặn. */
  so_tien_no_tu: number;
  chi_sv_co_email: boolean;
  /** "truong" | "ca_nhan" */
  uu_tien_email: string;
  /** Các ô lọc được hiện ở màn gửi. */
  cac_o_loc: string[];
}

export const tieuChiMacDinh = (): IMauEmailTieuChi => ({
  theo_ky_dang_chon: true,
  hoc_ky: 0,
  nam_hoc: "",
  filter_phamvi: "ky",
  id_svs: [],
  id_hes: [],
  id_khoas: [],
  khoa_hocs: [],
  id_nganhs: [],
  id_lops: [],
  id_khoi_nganhs: [],
  id_doi_tuongs: [],
  id_quoc_tichs: [],
  id_thu_chis: [],
  ky_dang_kys: [],
  tinh_chat_hocs: [],
  trang_thai_hocs: [],
  filter_congno: "chua-hoan-thanh",
  so_tien_no_tu: 0,
  chi_sv_co_email: true,
  uu_tien_email: "truong",
  // Không liệt kê O_LOC.SINH_VIEN: ô đó luôn hiện, không bật/tắt theo mẫu.
  cac_o_loc: [
    O_LOC.HE,
    O_LOC.KHOA,
    O_LOC.KHOA_HOC,
    O_LOC.LOP,
    O_LOC.KHOAN_THU,
    O_LOC.CONG_NO,
  ],
});

/** Một tham số cán bộ nhập lúc gửi, dùng trong mẫu bằng chỗ điền {ma}. */
export interface IMauEmailThamSo {
  ma: string;
  nhan: string;
  /** "text" | "date" | "number" */
  kieu: string;
  gia_tri: string;
  bat_buoc: boolean;
}

export interface IMauEmail {
  id: number;
  ma_mau: string;
  ten_mau: string;
  nhom: string;
  tieu_de: string;
  noi_dung: string;
  /** JSON nguyên văn từ máy chủ — dùng docTieuChi() để đọc. */
  tieu_chi: string;
  /** JSON nguyên văn từ máy chủ — dùng docThamSos() để đọc. */
  tham_so: string;
  is_su_dung: boolean;
  ghi_chu: string;
  created_time?: string;
  created_user_name?: string;
  created_user_code?: string;
  modified_time?: string;
  so_lan_gui: number;
  lan_gui_cuoi?: string;
}

/** Chỗ điền dùng được trong mẫu (máy chủ khai, giao diện chỉ hiện ra để bấm chèn). */
export interface IMauEmailBien {
  ma: string;
  mo_ta: string;
  vi_du: string;
  nhom: string;
}

export interface IMauEmailKhoanNo {
  id_thu_chi: number;
  ten_thu_chi: string;
  so_tien_phai_nop: number;
  so_tien_da_nop: number;
  so_tien_con_lai: number;
}

export interface IMauEmailSinhVien {
  id_sv: string;
  ma_sv: string;
  ho_ten: string;
  ten_lop: string;
  ten_he: string;
  ten_khoa: string;
  ten_nganh: string;
  khoa_hoc: number;
  email_truong: string;
  email_ca_nhan: string;
  /** Địa chỉ sẽ gửi tới (theo thứ tự ưu tiên khai trong tiêu chí). */
  email: string;
  so_tien_phai_nop: number;
  so_tien_da_nop: number;
  so_tien_mien_giam: number;
  so_tien_con_lai: number;
  so_lan_gui: number;
  lan_gui_cuoi?: string;
  ten_khoan_thu: string;
  khoan_nos: IMauEmailKhoanNo[];
}

export interface IMauEmailLocResult {
  data: IMauEmailSinhVien[];
  total_count: number;
  /** Số em KHÔNG có địa chỉ email (đã bị ẩn nếu tiêu chí chọn "chỉ sinh viên có email"). */
  so_khong_co_email: number;
  tong_tien_con_lai: number;
}

export interface IMauEmailXemTruoc {
  ma_sv: string;
  ho_ten: string;
  email: string;
  tieu_de: string;
  noi_dung: string;
  /** Chỗ điền không thay được (sai mã / thiếu tham số). */
  bien_thieu: string[];
}

export interface IMauEmailGuiResult {
  so_gui: number;
  so_bo_qua: number;
  bo_quas: string[];
  xem_truoc?: IMauEmailXemTruoc;
}

export interface IMauEmailLichSu {
  id: number;
  id_mau?: number;
  ten_mau: string;
  id_sv: string;
  ma_sv: string;
  ho_ten: string;
  ten_lop: string;
  email: string;
  tieu_de: string;
  noi_dung: string;
  so_tien_con_lai?: number;
  nam_hoc: string;
  hoc_ky: number;
  /** 0 = chờ gửi, 1 = đã gửi, 2 = lỗi. */
  trang_thai: number;
  ghi_chu: string;
  created_time?: string;
  created_user_name?: string;
}

export interface IMauEmailLichSuResult {
  data: IMauEmailLichSu[];
  total_count: number;
}

export interface IMauEmailSelectRequest {
  search_key: string;
  nhom: string;
  /** 1 = đang dùng, 0 = đã tắt, -1 = tất cả. */
  is_su_dung: number;
}

export interface IMauEmailSaveRequest {
  id: number;
  ma_mau: string;
  ten_mau: string;
  nhom: string;
  tieu_de: string;
  noi_dung: string;
  tieu_chi: IMauEmailTieuChi;
  tham_sos: IMauEmailThamSo[];
  is_su_dung: boolean;
  ghi_chu: string;
}

export interface IMauEmailLocRequest {
  id_mau: number;
  hoc_ky: number;
  nam_hoc: string;
  tieu_chi: IMauEmailTieuChi;
  search_key?: string;
  page_index?: number;
  page_size?: number;
}

export interface IMauEmailGuiRequest {
  id_mau: number;
  tieu_de: string;
  noi_dung: string;
  hoc_ky: number;
  nam_hoc: string;
  tieu_chi: IMauEmailTieuChi;
  tham_so_values: Record<string, string>;
  nguoi_nhans: { id_sv: string; email?: string }[];
  /** true = chỉ dựng thử email của em đầu tiên, KHÔNG gửi. */
  chi_xem_truoc?: boolean;
}

export interface IMauEmailLichSuRequest {
  id_mau: number;
  id_sv?: string;
  /** Ô "Mã sinh viên" — khớp một phần cũng ra. */
  ma_sv?: string;
  nam_hoc?: string;
  hoc_ky?: number;
  tu_ngay?: string;
  den_ngay?: string;
  /** -1 = mọi trạng thái. */
  trang_thai: number;
  search_key?: string;
  page_index: number;
  page_size: number;
}

/**
 * Hai cột tieu_chi / tham_so là JSON nguyên văn từ máy chủ: mẫu lưu từ bản cũ có thể thiếu
 * trường mới, nên luôn trộn với bản mặc định thay vì dùng trực tiếp.
 */
export const docTieuChi = (json?: string): IMauEmailTieuChi => {
  const macDinh = tieuChiMacDinh();
  if (!json) return macDinh;
  try {
    const doc = JSON.parse(json) as Partial<IMauEmailTieuChi>;
    return { ...macDinh, ...doc };
  } catch {
    return macDinh;
  }
};

export const docThamSos = (json?: string): IMauEmailThamSo[] => {
  if (!json) return [];
  try {
    const doc = JSON.parse(json);
    return Array.isArray(doc) ? (doc as IMauEmailThamSo[]) : [];
  } catch {
    return [];
  }
};

export const mauEmailApi = {
  Select: (request: IMauEmailSelectRequest) =>
    apiClient.post(`${ENDPOINT}/select`, request),
  SelectById: (id: number) => apiClient.get(`${ENDPOINT}/${id}`),
  Save: (request: IMauEmailSaveRequest) =>
    apiClient.post(`${ENDPOINT}/save`, request),
  Delete: (id: number) => apiClient.post(`${ENDPOINT}/delete/${id}`, {}),

  DanhSachBien: () => apiClient.get(`${ENDPOINT}/danh-sach-bien`),
  CoCauHinhSmtp: () => apiClient.get(`${ENDPOINT}/co-cau-hinh-smtp`),

  LocSinhVien: (request: IMauEmailLocRequest) =>
    apiClient.post(`${ENDPOINT}/loc-sinh-vien`, request),
  Gui: (request: IMauEmailGuiRequest) =>
    apiClient.post(`${ENDPOINT}/gui`, request),
  LichSu: (request: IMauEmailLichSuRequest) =>
    apiClient.post(`${ENDPOINT}/lich-su`, request),
};
